<template>
  <div class="container-fluid mt-4">
    <b-row
      class="mx-auto text-center"
      align-v="center"
      v-for="(Place, PlaceID) in Object.sortBy(Places)"
      :key="PlaceID"
    >
      <template v-if="Place.Tables && Object.keys(Place.Tables).length > 0">
        <b-col
          cols="12"
          :class="['noselect px-1 align-items-center', (PlaceID > 0) ? 'mt-5' : '']"
          v-if="Object.keys(Places).length > 1"
        >
          <b-alert show>{{ Place.Name }}</b-alert>
        </b-col>

        <b-col
          cols="3"
          md="2"
          class="noselect px-1 align-items-center table-link"
          v-for="(Table, TableIndex) in Object.sortBy(Place.Tables)"
          :key="TableIndex"
        >
          <router-link
            :to="`/Tables/${Table.ID}`"
            :class="`btn btn-huge btn-${(Table.Session) ? (Table.Session.Status === 1 ? 'success' : 'secondary') : 'outline-info'} align-items-center`"
            :style="`${(Table.Session) ? 'border-width:8px;' : ''}`"
          >
            <span class="table-name">
              {{ Table.Name }}
              <span
                class="total-price"
                v-if="Table.Session"
              >{{ parseFloat(TotalPrices[Table.ID]).Money() }}</span>
            </span>
          </router-link>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      TotalPrices: {}
    };
  },
  computed: {
    ...mapState(["StoreData"]),
    Places() {
      return this.StoreData.Places ? this.StoreData.Places : {};
    },
    Products() {
      return this.StoreData.Products ? this.StoreData.Products : {};
    }
  },
  methods: {
    Logout() {
      this.$store.dispatch("Logout");
    },
    async Refresh() {
      for (const p in this.Places) {
        let _Tables = this.Places[p].Tables;

        for (const t in _Tables) {
          let _Table = _Tables[t];
          let total = 0;

          if (_Table.Session !== undefined)
            for (const i in _Table.Session.Orders) {
              const _Order = _Table.Session.Orders[i];

              total += _Order.Portion * this.Products[_Order.ProductID].Price;

              if (typeof _Order.Extras === "object")
                for (const e in _Order.Extras) {
                  total += _Order.Portion * _Order.Extras[e].Price;
                }
            }

          await this.$set(this.TotalPrices, _Table.ID, total);
        }
      }
    }
  },
  async mounted() {
    await this.Refresh();

    this.$store.subscribe(async mutation => {
      if (["Up", "Del", "UpdateState"].indexOf(mutation.type) !== -1) {
        await this.Refresh();
        await this.$nextTick();
        await this.$forceUpdate();
      }
    });
  }
};
</script>
